var _title, _desc, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcUpload = function SvgIcUpload(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "17px",
    viewBox: "0 0 21 17",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Group 2")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Post-a-part",
    transform: "translate(-196.000000, -312.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(183.000000, 303.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(13.000000, 9.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.83,1.33 C18.66,1.33 19.33,2 19.33,2.83 L19.33,13.84 C19.33,14.67 18.66,15.34 17.83,15.34 L2.83,15.34 C2,15.34 1.33,14.67 1.33,13.84 L1.33,2.83 C1.33,2 2,1.33 2.83,1.33 L17.83,1.33 L17.83,1.33 Z M17.83,-8.73967565e-13 L2.83,-8.73967565e-13 C1.27,-8.73967565e-13 1.74615877e-12,1.27 1.74615877e-12,2.83 L1.74615877e-12,13.84 C1.74615877e-12,15.4 1.27,16.67 2.83,16.67 L17.83,16.67 C19.39,16.67 20.66,15.4 20.66,13.84 L20.66,2.83 C20.66,1.27 19.39,-8.73967565e-13 17.83,-8.73967565e-13 L17.83,-8.73967565e-13 Z",
    id: "Shape",
    fill: "#292A2F",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.93,3.96 C15.48,3.96 15.93,4.41 15.93,4.96 C15.93,5.51 15.48,5.96 14.93,5.96 C14.38,5.96 13.93,5.51 13.93,4.96 C13.93,4.4 14.38,3.96 14.93,3.96 L14.93,3.96 Z M14.93,2.62 C13.64,2.62 12.6,3.67 12.6,4.95 C12.6,6.23 13.65,7.28 14.93,7.28 C16.21,7.28 17.26,6.23 17.26,4.95 C17.26,3.67 16.22,2.62 14.93,2.62 L14.93,2.62 Z",
    id: "Shape",
    fill: "#292A2F",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.97,15.33 L7.81,6.77 C7.85,6.71 7.93,6.71 7.97,6.77 L10.83,10.63 C10.87,10.68 10.94,10.68 10.98,10.64 L12.88,8.84 C12.92,8.8 12.99,8.8 13.02,8.85 L18.7,15.34",
    id: "Path",
    stroke: "#292A2F",
    strokeWidth: 1.332,
    strokeLinecap: "square"
  })))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcUpload, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_upload.cf16736c.svg";
export { ForwardRef as ReactComponent };